import { render, staticRenderFns } from "./CardPropertyDate.vue?vue&type=template&id=54ee72ec&"
import script from "./CardPropertyDate.vue?vue&type=script&lang=js&"
export * from "./CardPropertyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports